import React from 'react';
import { useQuery } from 'react-query';
import { RiDatabase2Fill } from 'react-icons/ri';
import { MdFiberManualRecord, MdCompareArrows } from 'react-icons/md';
import CircularProgress from '@mui/material/CircularProgress';

import { getMainStatus, getBackupStatus, getDbSynchroStatus } from '../api/admin';

// import PropTypes from 'prop-types';

function Footer() {
  const { data: mainStatus, isLoading: mainIsLoading } = useQuery('mainDB', getMainStatus, {
    refetchInterval: 60 * 1000,
  });

  const { data: backupStatus, isLoading: backupIsLoading } = useQuery('backupDB', getBackupStatus, {
    refetchInterval: 60 * 1000,
  });

  const { data: synchroStatus, isLoading: synchroIsLoading } = useQuery('synchroDB', getDbSynchroStatus, {
    refetchInterval: 3 * 1000,
  });

  return (
    <div className="footer bg-zinc-900 grid justify-end items-center px-4">
      <div className="flex items-center space-x-8">
        <div className="flex items-center space-x-1">
          <RiDatabase2Fill />
          {mainIsLoading ? (
            <CircularProgress size={15} />
          ) : (
            <div className="flex items-center" title={mainStatus?.message}>
              <MdFiberManualRecord
                className={mainStatus?.connected && 'glow'}
                color={mainStatus?.connected ? 'var(--on)' : 'var(--off)'}
              />
              <span>{mainStatus?.ip}</span>
            </div>
          )}
        </div>
        <div className="flex items-center space-x-1">
          <RiDatabase2Fill />
          {backupIsLoading ? (
            <CircularProgress size={15} />
          ) : (
            <div className="flex items-center" title={backupStatus?.message}>
              <MdFiberManualRecord
                className={backupStatus?.connected && 'glow'}
                color={backupStatus?.connected ? 'var(--on)' : 'var(--off)'}
              />
              <span>{backupStatus?.ip}</span>
            </div>
          )}
        </div>

        <div>
          {synchroIsLoading ? (
            <div className="flex items-center space-x-1">
              <MdCompareArrows size={20} color="var(--dark-600)" />
              <CircularProgress size={15} />
            </div>
          ) : (
            <MdCompareArrows
              title={synchroStatus?.synchro ? 'Réplication activée' : 'Réplication désactivée'}
              size={20}
              color={synchroStatus?.synchro ? 'var(--on)' : 'var(--off)'}
            />
          )}
        </div>
      </div>
    </div>
  );
}

Footer.propTypes = {};

export default Footer;
